module.exports = __webpack_public_path__ + "static/media/Yoyo_4422.6cbd9242.jpg";